(function documentControllerDefinition() {
    'use strict';

    angular.module('Document')
        .controller('DocumentDetailController', [
            '$scope', '$translate', '$state', 'errorsExtend', '$stateParams', 'documentService', 'fileService', 'fileDownloader', 'authExtend', 'auth', 'alerts', '$q', 'storageService', 'documentAction', 'myDocument', 'documentTypeService', 'workflowService', '$filter', 'config', 'documentsShortcutsService', 'favoritesService',
            function documentDetailController($scope, $translate, $state, errors, $stateParams, documentService, fileService, fileDownloader, authExtend, auth, alerts, $q, storageService, documentAction, myDocument, documentTypeService, workflowService, $filter, config, documentsShortcutsService, favoritesService) {
                $scope.hasOCR = authExtend.isInRole('OCR');
                $scope.hasFullText = authExtend.isInRole('FULLTEXT');
                $scope.PendingOcr = 'PO';
                $scope.activiti = authExtend.isInRole('ACTIVITI');
                $scope.canStartWorkflow = authExtend.isInRole('WORKFLOW START PROCESS');
                $scope.canCheckInAndStartWorkflow = authExtend.isInRole('WORKFLOW START PROCESS');
                $scope.maxSearchCaracters = config.searchTableMaxLength();
                $scope.viewAudit = auth.isInRole('AUDIT READ');
                $scope.UserId = authExtend.getUserId();
                $scope.ouName = authExtend.getOrganizationName();
                $scope.urlFind = undefined;
                $scope.hasHash = false;
                $scope.isDocumentLoaded = false;
                $scope.hasFilesFromSystems = false;
                $scope.metadataAccordionOpened = true;
                $scope.filesAccordionOpened = true;
                $scope.notifsAccordionOpened = true;
                $scope.workflowAccordionOpened = true;
                $scope.workflows = [];
                $scope.fileToReplace = null;
                $scope.favorited = false;
                $scope.hideFavorite = false;
                $scope.canReplace = false;

                $scope.loadActions = function () {
                    if ($scope.document.documentTypes.length === 0) {
                        return;
                    }

                    documentTypeService.isDoctypeInRole(['DOCUMENTVERSIONED WRITE'], $scope.document.documentTypes[0].documentTypeId).then(function (r) { $scope.checkInVersioned = r; });
                    documentTypeService.isDoctypeInRole(['DOCUMENT WRITE'], $scope.document.documentTypes[0].documentTypeId).then(function (r) { $scope.accesCheckIn = r; });
                    documentTypeService.isDoctypeInRole(['DOCUMENTVERSIONED WRITE', 'DOCUMENT WRITE'], $scope.document.documentTypes[0].documentTypeId).then(function (r) { $scope.modifyOptions = r; });
                    documentTypeService.isDoctypeInRole(['FILE DOWNLOAD'], $scope.document.documentTypes[0].documentTypeId).then(function (r) { $scope.downloadBtn = r; });
                    documentTypeService.isDoctypeInRole(['FILE READ'], $scope.document.documentTypes[0].documentTypeId).then(function (r) { $scope.viewPDFBtn = r; });
                    documentTypeService.isDoctypeInRole(['DOCUMENT DELETE'], $scope.document.documentTypes[0].documentTypeId).then(function (r) { $scope.deleteOptions = r; });
                    documentTypeService.isDoctypeInRole(['DOCUMENT IMAGE READ'], $scope.document.documentTypes[0].documentTypeId).then(function (r) { $scope.hasImageModule = r; });
                    documentTypeService.isDoctypeInRole(['DOCUMENT SIGN', 'DOCUMENTVERSION SIGN'], $scope.document.documentTypes[0].documentTypeId).then(function (r) { $scope.canBeSigned = r; });
                    documentTypeService.isDoctypeInRole(['DOCUMENTVERSION READ'], $scope.document.documentTypes[0].documentTypeId).then(function (r) { $scope.versionView = r; });
                }

                $scope.initDocumentFind = function () {
                    if ($scope.urlFind) {
                        $state.go($scope.urlFind);
                    }
                };
                $scope.openAccordion = function () {
                    if ($scope.isDocumentLoaded) {
                        $scope.accordionOpened = !$scope.accordionOpened;
                        $scope.document.files.forEach(function (item) {
                            item.accordionIsOpen = $scope.accordionOpened;
                        });
                        $scope.document.files.forEach(function (file) {
                            fileService.getSignatures(file.id).then(function (result) {
                                file.signatures = result;
                            }, function (error) {
                                errors.showError(error);
                            });
                        });
                    }
                };

                $scope.openMetadataAccordion = function () {
                    if ($scope.isDocumentLoaded) {
                        $scope.metadataAccordionOpened = !$scope.metadataAccordionOpened;
                    }
                };

                $scope.openFilesAccordion = function () {
                    if ($scope.isDocumentLoaded) {
                        $scope.filesAccordionOpened = !$scope.filesAccordionOpened;
                    }
                };

                $scope.openNotifsAccordion = function () {
                    if ($scope.isDocumentLoaded) {
                        $scope.notifsAccordionOpened = !$scope.notifsAccordionOpened;
                    }
                };

                $scope.openWorkflowAccordion = function () {
                    if ($scope.isDocumentLoaded) {
                        $scope.workflowAccordionOpened = !$scope.workflowAccordionOpened;
                    }
                };

                $scope.goBackToContainer = function () {
                    $state.go('document-container-detail-from-doc', { id: $scope.containerId, docId: $scope.document.id });
                };

                $scope.cancel = function () {
                    if (storageService.getStateBackFind()) {
                        $state.go(storageService.getStateBackFind());
                    } else {
                        $state.goBack('inicio');
                    }
                };

                $translate(['DocumentVersionDetail']).then(function (translated) {
                    $scope.title = translated.DocumentVersionDetailTitle;
                });

                $scope.loadDocument = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    if ($stateParams.nro) {
                        documentService.getVersion($stateParams.id, $stateParams.nro).then(function (result) {
                            defered.resolve(result);
                        }, function (error) {
                            defered.reject(error);
                        });
                    } else {
                        documentService.getById($stateParams.id, myDocument).then(function (result) {
                            var res = result;

                            defered.resolve(result);
                        }, function (error) {
                            defered.reject(error);
                        });
                    }

                    workflowService.getDocumentWorkFlows($stateParams.id).then(function (result) {
                        $scope.workflows = result;
                        var activeWorkflows = $filter('filter')($scope.workflows, { isActive: true }, true);
                        if ($scope.workflows.length > 0) {
                            $scope.canStartWorkflow = (activeWorkflows.length === 0);
                        };
                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                }

                $scope.startWFAndCheckIn = function (document) {
                    return documentAction.startWFAndCheckIn(document).then(function () {
                        if ($scope.containerId) {
                            $state.go('document-detail-container', {
                                id: $scope.document.id,
                                containerId: $scope.containerId
                            });
                        } else {
                            $scope.cancel();
                        }
                    }, function () {
                        $scope.load();
                    });
                };

                $scope.load = function () {
                    $scope.btnLogistic = false;
                    $scope.urlFind = storageService.getStateBackFind();

                    $scope.loadDocument().then(function (result) {
                        $scope.document = result;
                        $scope.canCheckOut = result.checkedOutById === null || (result.checkedOutByExpiration && new Date() > new Date(result.checkedOutByExpiration));
                        $scope.canReplace = ($scope.canCheckOut || (result.checkedOutById === $scope.UserId && myDocument));
                        $scope.loadActions();

                        $scope.document.hasMetadata = ($scope.metadataCount(result) !== 0);
                        $scope.document.documentTypes.forEach(function (docType) {
                            docType.metadatas.sort(function (a, b) {
                                return a.position - b.position;
                            });
                        });

                        if ($scope.downloadBtn) {
                            $scope.downloadBtn = ($scope.document.files.length > 0);
                        }

                        $scope.document.files.forEach(function (file) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            if (file.isSystemCreated) {
                                //si tiene al menos un doc con imagenes, y habilitado el modulo, muestro el btn.
                                $scope.hasFilesFromSystems = true;
                            }

                            var extn = file.name.split(".").pop();

                            // Agregar validación si ya se encuentra firmado
                            file.canBeSigned = (extn === 'pdf') && ($scope.document.checkedOutById === null);

                            if (!angular.isDefined(file.resultadoHash)) {
                                file.resultadoHash = "notCalculated";
                                if (file.hasHash) {
                                    $scope.hasHash = true;
                                }
                            }
                        });

                        $scope.isDocumentLoaded = true;

                        if ($stateParams.containerId) {
                            $scope.document.containers.forEach(function (cont) {
                                if (cont.id.toString() === $stateParams.containerId.toString()) {
                                    $scope.containerId = $stateParams.containerId;
                                    return;
                                }
                            });
                        }

                        $scope.hideFavorite = $scope.document.versionId === 1 && $scope.document.isTempVersion;

                        favoritesService.exists($stateParams.id, 'DOCUMENTS').then(function (isInFavorites) {
                            $scope.favorited = isInFavorites;
                        }, function (error) {
                            errors.showError(error);
                        });
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                };

                $scope.viewPDF = function (file) {
                    if (file) {
                        if (myDocument) {
                            $state.go('myfile-document-detail-one', { id: $stateParams.id, version: $scope.document.versionId, file: file.id });
                        } else {
                            $state.go('file-document-detail-one', { id: $stateParams.id, version: $scope.document.versionId, file: file.id });
                        }
                    } else {
                        if (myDocument) {
                            $state.go('myfile-document-detail', { id: $stateParams.id, version: $scope.document.versionId });
                        } else {
                            $state.go('file-document-detail', { id: $stateParams.id, version: $scope.document.versionId });
                        }
                    }
                };

                $scope.openFileAccordion = function (file) {
                    if ($scope.isDocumentLoaded) {
                        fileService.getSignatures(file.id).then(function (result) {
                            file.signatures = result;
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.signPDF = function (file) {
                    if (file) {
                        $state.go('file-document-sign', {
                            id: $stateParams.id,
                            version: $scope.document.versionId,
                            file: file.id
                        });
                    }
                };

                $scope.replaceFile = function (file) {
                    if (file) {
                        $scope.fileToReplace = file;
                    }
                };

                $scope.replaceFileSelected = function (file) {
                    if (file.replaceFile) {
                        var replaceDto = {
                            documentId: $stateParams.id,
                            shouldPublish: $scope.document.checkedOutById !== $scope.UserId,
                            fileToReplace: $scope.fileToReplace.id
                        }
                        $scope.fileReplace = file;
                        documentsShortcutsService.replaceFile(replaceDto, file).then(function (result) {
                            $scope.load();
                        }, function (error) {
                            errors.showError(error);
                        });
                    }

                    $scope.fileToReplace = null;
                }

                $scope.startWorkflow = function () {
                    workflowService.startWorkFlow($scope.document.id, $scope.document.name, $scope.document.documentType, $scope.document.versionId).then(function (result) {
                        errors.showSuccess('WorkFlowStartedSuccessfully');
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.myView = function (document) {
                    if ($scope.containerId) {
                        $state.go('mydocument-detail-container', { id: document.id, containerId: $scope.containerId });
                    } else {
                        $state.go('mydocument-detail', { id: document.id });
                    }
                }

                $scope.viewVersion = function () {
                    $state.go('document-version-all', { id: $stateParams.id });
                };

                $scope.viewInformation = function () {
                    if (myDocument) {
                        $state.go('mydocument-detail-images', { id: $stateParams.id });
                    } else {
                        $state.go('document-detail-images', { id: $stateParams.id });
                    }
                };

                $scope.downloadFile = function (file) {
                    return fileService.download(file.id).then(function (result) {
                        var success = fileDownloader.saveAs(result, file.name);
                        if (!success) {
                            errors.showError('Api failed');
                        }

                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }
                    });
                }

                $scope.downloadFilesDocument = function () {
                    return documentAction.downloadFiles($scope.document);
                }

                $scope.hashFilesDocument = function () {
                    $scope.document.files.forEach(function (item) {
                        $scope.validateHashFile(item);
                    });
                }

                $scope.validateHashFile = function (file) {
                    var res = fileService.validateHash(file.id).then(function (result) {
                        if (result) {
                            file.resultadoHash = "valid";

                        } else {
                            file.resultadoHash = "invalid";

                        }

                    });

                    return res;
                }

                $scope.askOcr = function (file) {
                    return fileService.askOcr(file.id).then(function (result) {
                        file.flagOcrFullSearch = result.flagOcrFullSearch;
                        file.isPendingOcr = result.isPendingOcr;
                    }, function (error) {
                        errors.showError(error);
                        $scope.load();
                    });
                }

                $scope.modify = function () {
                    $state.go('document-modify', { id: $stateParams.id });
                }

                $scope.checkIn = function () {
                    return documentAction.checkIn($scope.document)
                        .then(function () {
                            if ($scope.containerId) {
                                $state.go('document-detail-container', {
                                    id: $scope.document.id,
                                    containerId: $scope.containerId
                                });
                            } else {
                                $scope.cancel();
                            }
                        }, function () {
                            $scope.load();
                        });
                };

                $scope.delete = function () {
                    return $translate(['Warning', 'DocumentVersionDeleteConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.DocumentVersionDeleteConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (result) {
                                return documentService.deleteVersion($scope.document).then(function getOk(result) {
                                    $scope.document = result;

                                    errors.showSuccess('DocumentVersionDeleteSucces');
                                    if ($scope.document) {
                                        $state.go('document-detail', { id: $scope.document.id });
                                    } else {
                                        if (storageService.getStateBackFind()) {
                                            $state.go(storageService.getStateBackFind());
                                        } else {
                                            $state.go('inicio');
                                        }
                                    }
                                }, function (error) {
                                    errors.showError(error);
                                    $scope.load();
                                });
                            }
                        });
                    });
                };

                $scope.checkout = function () {

                    return documentAction.checkOut($scope.document)
                        .then(function getOk(result) {
                            $state.go('document-modify', { id: $scope.document.id });
                        }, function (error) {
                            $scope.load();
                        });
                };

                $scope.metadataCount = function (document) {
                    if (document.documentTypes && document.documentTypes.length) {
                        return document.documentTypes.reduce(function (valorPrevio, valorActual, indice, array) { return valorPrevio + valorActual.metadatas.length; }, 0);
                    }
                    return 0;
                };

                $scope.seeContainerDetail = function (container, document) {
                    $state.go('document-container-detail-from-doc', { id: container.id, docId: document.id });
                };

                $scope.deleteDocument = function () {
                    return documentAction.deleteDocument($scope.document).then(function (doc) {
                        if (storageService.getStateBackFind()) {
                            $state.go(storageService.getStateBackFind());
                        } else {
                            $state.go('inicio');
                        }
                    });
                };

                $scope.viewAuditHistory = function () {
                    var params = [];
                    params.push($scope.document.id);

                    $state.go('audit-history', {
                        entityName: "DOCUMENT",
                        entityValues: params,
                        displayName: $scope.document.name
                    });
                };

                $scope.addFavorite = function () {
                    return favoritesService.addFavorite($stateParams.id, 'DOCUMENTS').then(function getOk(result) {
                        $scope.favorited = true;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.removeFavorite = function () {
                    return favoritesService.removeFavorite($stateParams.id, 'DOCUMENTS').then(function getOk(result) {
                        $scope.favorited = false;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.load();
            }
        ]);
})();